import Decimal from 'decimal.js';

export const ZERO_DECIMAL_CURRENCIES: Currency[] = ['JPY', 'ISK', 'KRW', 'VND', 'XAF', 'XOF', 'XPF'];

export const convertMonetaryIntToDecimal = (amount: number | null, currency: Currency) =>
  ZERO_DECIMAL_CURRENCIES.includes(currency) ? amount ?? 0 : Decimal.div(amount ?? 0, 100).toNumber();

export const convertDecimalToMonetaryInt = (amount: number | null, currency: Currency) =>
  ZERO_DECIMAL_CURRENCIES.includes(currency) ? amount ?? 0 : Decimal.mul(amount ?? 0, 100).toNumber();
